module.exports = __webpack_public_path__ + "img/dash-box-arrow-black.f4942ab5.svg";